export const ID_GENERATION = {
  BASE: 36,
  START_INDEX: 2,
  END_INDEX: 15,
} as const;

export function generateRandomId(): string {
  return Math.random().toString(ID_GENERATION.BASE).substring(ID_GENERATION.START_INDEX, ID_GENERATION.END_INDEX);
}
